/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Upload_ChooseInputs */

const cs_chat_attach_upload_choose = /** @type {(inputs: Chat_Attach_Upload_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat soubor`)
};

const en_chat_attach_upload_choose = /** @type {(inputs: Chat_Attach_Upload_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose file`)
};

/**
* | output |
* | --- |
* | "Choose file" |
*
* @param {Chat_Attach_Upload_ChooseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_upload_choose = /** @type {((inputs?: Chat_Attach_Upload_ChooseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Upload_ChooseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_upload_choose(inputs)
	return cs_chat_attach_upload_choose(inputs)
});